import React from 'react';

import Modal from '../Modal/Modal';

import './InfoComponent.scss';

interface InfoComponentInterface {
    title?: string;
    text?: string;
    nested?: boolean;
    centerHorizontally?: boolean;
}

const InfoComponent: React.FunctionComponent<InfoComponentInterface> = (props) => {
    const [modalVisible, setModalVisibility] = React.useState<boolean>(false);

    if (!props.text && !props.children) {
        return null;
    }

    const toggleVisibility = () => setModalVisibility(!modalVisible);

    const nested = Boolean(props.nested);
    const centerHorizontally = Boolean(props.centerHorizontally);

    return (
        <>
            <svg className="icon icon--info info-component" onClick={() => setModalVisibility(true)}>
                <use xlinkHref="#icon-info" />
            </svg>
            <Modal
                visible={modalVisible}
                toggleVisibility={toggleVisibility}
                nested={nested}
                centerHorizontally={centerHorizontally}
            >
                <div className="info-box">
                    {props.title ? <h2>{props.title}</h2> : null}

                    {props.text ? <div dangerouslySetInnerHTML={{ __html: props.text }} /> : null}
                    {props.children}
                </div>
            </Modal>
        </>
    );
};

export default InfoComponent;
